import { queryOptions, useMutation, useQueryClient, useSuspenseQuery } from '@tanstack/react-query'
import { createParent, getParents, type CreateParentRequest, type Parent } from './api'

export const parentsQueryOptions = () =>
    queryOptions<Parent[]>({
        queryKey: ['parents', 'with-students-v3'],
        queryFn: () => getParents(),
    })

export function useParents() {
    return useSuspenseQuery(parentsQueryOptions())
}

export function useCreateParentMutation() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: (body: CreateParentRequest) => createParent(body),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['parents'] }),
    })
}
